import { PurchasingRepository } from '@Purchasing/Data/Repository/PurchasingRepository'
import { PurchasePreparation } from '@Purchasing/Domain/Model/PurchaseProcess'
import {
    BatchCreationResult,
    CreateProcessBatchPayload,
} from '@Purchasing/Data/DataSource/API/Entity/PurchaseProcess'

export interface GetPurchasePreparation {
    execute(params: {
        budgetCode?: number
        externalId?: string
    }): Promise<PurchasePreparation>
}

export class GetPurchasePreparationUseCase implements GetPurchasePreparation {
    constructor(private repository: PurchasingRepository) {}
    execute(params: {
        budgetCode?: number
        externalId?: string
    }): Promise<PurchasePreparation> {
        return this.repository.getPreparation(params)
    }
}

export interface CreateProcessesBatch {
    execute(
        payload: CreateProcessBatchPayload
    ): Promise<BatchCreationResult>
}

export class CreateProcessesBatchUseCase implements CreateProcessesBatch {
    constructor(private repository: PurchasingRepository) {}
    execute(
        payload: CreateProcessBatchPayload
    ): Promise<BatchCreationResult> {
        return this.repository.createBatch(payload)
    }
}
